import { PartialTransfer } from '@features/ForestOwner/EditShareOwnership/PartialTransfer/PartialTransfer'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/forestowner/$forestownerId/shareownership/editShareOwnership/partialTransfer/',
)({
  component: RouteComponent,
  staticData: {
    breadcrumb: 'Delvis overdragelse',
  },
})

function RouteComponent() {
  return <PartialTransfer />
}
